import React, { useEffect, useState } from "react"
import { Col, Row, UncontrolledAlert, Spinner } from "reactstrap"
import api from "API/Api"
import { AvForm, AvField, AvRadioGroup, AvRadio } from "availity-reactstrap-validation"
import { Link } from "react-router-dom"
import PageLoader from "./../../../assets/loading/pageLoad1.gif"

const AddCenterBonusBill = () => {
  const user = localStorage.getItem("authUser")
  const userInfo = user ? JSON.parse(user) : {}
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [pageLoad, setPageLoad] = useState(true)
  const [centers, setCenters] = useState([])
  const [routes, setRoutes] = useState([])
  const [collections, setCollections] = useState([])
  const [routesLoading, setRoutesLoading] = useState(false)
  const [collectionsLoading, setCollectionsLoading] = useState(false)

  useEffect(() => { getData() }, [])

  const getData = async () => {
    try {
      const resp = await api.get("centers?per_page=500")
      setCenters(Array.isArray(resp.data?.data) ? resp.data.data : resp.data?.data?.data || [])
    } catch (e) { console.error(e) }
    setPageLoad(false)
  }

  const onCenterChange = async (value) => {
    setRoutes([]); setCollections([])
    if (!value) return
    setRoutesLoading(true)
    try {
      const resp = await api.get("route-cc/" + value)
      setRoutes(Array.isArray(resp.data?.data) ? resp.data.data : resp.data?.data?.data || [])
    } catch (e) { console.error(e) }
    setRoutesLoading(false)
  }

  const onRouteChange = async (value) => {
    setCollections([])
    if (!value) return
    setCollectionsLoading(true)
    try {
      const resp = await api.get("collection-center-route/" + value)
      setCollections(Array.isArray(resp.data?.data) ? resp.data.data : resp.data?.data?.data || [])
    } catch (e) { console.error(e) }
    setCollectionsLoading(false)
  }

  const handleValidSubmit = async (event, values) => {
    if (values.bonusFrom && values.bonusTo && values.bonusFrom > values.bonusTo) {
      alert("Bonus period 'From' must be before 'To'"); return
    }
    values.added_by = userInfo.uid
    setLoading(true); setSubmitted(false)
    try {
      const resp = await api.post("create-center-bonus-bill", values)
      if (resp.data.success) { setSubmitted(true); setTimeout(() => setSubmitted(false), 4000) }
    } catch (e) { console.error(e) }
    setLoading(false)
  }

  const today = new Date().toISOString().split("T")[0]
  if (pageLoad) return <div className="pageLoader"><img src={PageLoader} alt="Loading..." /></div>

  return (
    <div className="dashBody">
      <div className="font-size-18 mb-0 dashHeader">
        <Row>
          <Col md={6}><h4>Add Center Bonus Bill</h4></Col>
          <Col md={6} style={{textAlign:"right"}}><Link to="/vlcc-bonus-bills" className="dashBtn"><i className="fas fa-chevron-left"></i> <b>Back</b></Link></Col>
        </Row>
      </div>
      <div className="dashContent">
        <AvForm className="form-horizontal" onValidSubmit={(e,v)=>handleValidSubmit(e,v)}>
          <h6 style={{color:"#6366f1",borderBottom:"2px solid #e2e8f0",paddingBottom:"8px",marginBottom:"16px"}}><i className="fas fa-map-marker-alt"></i> Location Details</h6>
          <Row>
            <Col md={4}><div className="mb-3">
              <AvField type="select" name="chillingCenter" label="Chilling Center" required onChange={e=>onCenterChange(e.target.value)}>
                <option value="">Select Chilling Center</option>
                {centers.map((c,i) => <option key={i} value={c.id}>{c.name}</option>)}
              </AvField>
            </div></Col>
            <Col md={4}><div className="mb-3">
              <AvField type="select" name="route" label={routesLoading?"Loading Routes...":"Route"} required onChange={e=>onRouteChange(e.target.value)}>
                <option value="">{routesLoading?"Loading...":"Select Route"}</option>
                {routes.map((r,i) => <option key={i} value={r.id}>{r.routeName}</option>)}
              </AvField>
            </div></Col>
            <Col md={4}><div className="mb-3">
              <AvField type="select" name="collectionCenter" label={collectionsLoading?"Loading...":"Collection Center"} required>
                <option value="">{collectionsLoading?"Loading...":"Select Collection Center"}</option>
                {collections.map((c,i) => <option key={i} value={c.id}>{c.centerName}</option>)}
              </AvField>
            </div></Col>
          </Row>

          <h6 style={{color:"#6366f1",borderBottom:"2px solid #e2e8f0",paddingBottom:"8px",marginBottom:"16px",marginTop:"8px"}}><i className="fas fa-calendar-alt"></i> Bonus Period</h6>
          <Row>
            <Col md={4}><div className="mb-3"><AvField name="bonusBillDate" label="Bonus Bill Date" type="date" value={today} required /></div></Col>
            <Col md={4}><div className="mb-3"><AvField name="bonusFrom" label="Period From" type="date" required /></div></Col>
            <Col md={4}><div className="mb-3"><AvField name="bonusTo" label="Period To" type="date" required /></div></Col>
          </Row>

          <h6 style={{color:"#6366f1",borderBottom:"2px solid #e2e8f0",paddingBottom:"8px",marginBottom:"16px",marginTop:"8px"}}><i className="fas fa-gift"></i> Bonus Details</h6>
          <Row>
            <Col md={4}><div className="mb-3">
              <AvRadioGroup inline name="calculateOn" label="Calculate On" required errorMessage="Pick one!">
                <AvRadio label="Quantity Liters" value="1" />
                <AvRadio label="Quantity KG" value="2" />
                <AvRadio label="Amount" value="3" />
              </AvRadioGroup>
            </div></Col>
            <Col md={4}><div className="mb-3">
              <AvField type="select" name="bonusType" label="Bonus Type" required>
                <option value="">Select Bonus Type</option>
                <option value="quality">Quality Bonus</option>
                <option value="quantity">Quantity Bonus</option>
                <option value="loyalty">Loyalty Bonus</option>
                <option value="festive">Festive Bonus</option>
                <option value="other">Other</option>
              </AvField>
            </div></Col>
            <Col md={4}><div className="mb-3"><AvField name="bonusValue" label="Bonus Value (Rate/Unit)" type="number" step="0.01" required validate={{min:{value:0}}} /></div></Col>
            <Col md={4}><div className="mb-3"><AvField name="bonusAmount" label="Bonus Amount (₹)" type="number" step="0.01" value="0" validate={{min:{value:0}}} helpMessage="Total bonus amount for this period" /></div></Col>
            <Col md={8}><div className="mb-3"><AvField name="remarks" label="Remarks" type="textarea" rows="2" /></div></Col>
          </Row>

          <div className="mb-3 row mt-4">
            <div className="col-6">{submitted && <UncontrolledAlert color="success"><strong>Center Bonus Bill Added!</strong></UncontrolledAlert>}</div>
            <div className="col-6 text-end">
              <button className="btn btn-primary w-md waves-effect waves-light" type="submit" disabled={loading}>
                {loading ? <><Spinner animation="border" size="sm" /><span style={{paddingLeft:"10px"}}>Saving...</span></> : <span><i className="fas fa-save"></i> Save Bill</span>}
              </button>
            </div>
          </div>
        </AvForm>
      </div>
    </div>
  )
}
export default AddCenterBonusBill
